import { XIcon } from '../../icons/XIcon';
import { cn } from '../../utils';
import { FormTagVariant } from './FormTagField.utils';

export interface TagProps {
  value: string;
  variant?: FormTagVariant;
  onRemove?: () => void;
}

const tagVariants: Record<FormTagVariant, string> = {
  default: 'bg-[#D2DFFD] text-primary',
  warning: 'bg-[#FFE39C] text-[#765605]',
  error: 'bg-[#FFDFEC] text-[#E02D75]',
};

export const FormTag = ({ value, onRemove, variant = 'default' }: TagProps) => {
  return (
    <span
      className={cn(
        'leading[18px] flex items-center gap-1.5 rounded-sm py-0.5 pr-1.5 pl-2.5 text-sm',
        tagVariants[variant]
      )}
    >
      {value}
      <button onClick={onRemove}>
        <XIcon className="size-3 cursor-pointer" />
      </button>
    </span>
  );
};
